<template lang="pug">
v-menu(
  ref='picker'
  v-model='picker'
  full-width
  min-width='290px'
  :return-value.sync='model'
  :close-on-content-click='false'
  :disabled='disabled'
  lazy
)
  v-text-field(
    slot='activator'
    v-model='model'
    :label='label'
    :error='validator && validator.has(name)'
    :error-messages='validator && validator.first(name)'
    :disabled='disabled'
    prepend-icon='date_range'
    readonly
    clearable
  )
  v-date-picker(
    scrollable
    locale='ru-RU'
    v-model='model'
    :readonly='disabled'
    @input='$refs.picker.save(model)'
    :first-day-of-week='1'
    :min='min'
  )
</template>

<script>
export default {
  props: {
    value: {
      type: null,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    validator: {
      type: Object,
      required: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: 'Дата рождения'
    },
    min: {
      type: String
    }
  },

  data: () => ({
    model: null,
    picker: false
  }),

  created() {
    this.model = this.value
  },

  watch: {
    model(val) {
      this.$emit('input', val)
    },

    value(val) {
      this.model = val
    }
  }
}
</script>
